/* eslint-disable no-secrets/no-secrets */
/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import styles from './ProductsorServicesComponent.module.scss';
import metadata from './ProductsorServicesComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function ProductsorServicesComponent(props) {

    const {
        data: ProductsorServicesVM,
        updateWizardData,
        submissionVM,
        ProductsorServicesPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addProductsorServices = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            ProductsorServicesVM.value = ProductsorServicesVM.value || []

            const { _xCenter, _dtoName } = ProductsorServicesVM;

            const ProductsorServicesObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            ProductsorServicesVM.pushElement(
                ProductsorServicesObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, ProductsorServicesVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            ProductsorServicesVM.value.splice(index, 1);
            _.set(submissionVM.value, ProductsorServicesPath, ProductsorServicesVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, ProductsorServicesPath, ProductsorServicesVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'natOfWor1') {
                const value = (item && item.natOfWor1) ? item.natOfWor1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = ProductsorServicesVM.length > 0 && ProductsorServicesVM.children[index].natOfWor1
                    // eslint-disable-next-line security/detect-object-injection
                    ? ProductsorServicesVM.children[index].natOfWor1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.natOfWor1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }



            if (path === 'per2') {
                const value = item.per2 ? item.per2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.per2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'actRevForExpTerCdn3') {
                const value = item.actRevForExpTerCdn3 ? item.actRevForExpTerCdn3 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.actRevForExpTerCdn3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'actRevForExpTerUs4') {
                const value = item.actRevForExpTerUs4 ? item.actRevForExpTerUs4 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.actRevForExpTerUs4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'actRevForExpTerFor5') {
                const value = item.actRevForExpTerFor5 ? item.actRevForExpTerFor5 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.actRevForExpTerFor5 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'estAnnRevNex12MonCdn6') {
                const value = item.estAnnRevNex12MonCdn6 ? item.estAnnRevNex12MonCdn6 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.estAnnRevNex12MonCdn6 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'estAnnRevNex12MonUs7') {
                const value = item.estAnnRevNex12MonUs7 ? item.estAnnRevNex12MonUs7 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.estAnnRevNex12MonUs7 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'estAnnRevNex12MonFor8') {
                const value = item.estAnnRevNex12MonFor8 ? item.estAnnRevNex12MonFor8 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.estAnnRevNex12MonFor8 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'des9') {
                const value = item.des9 ? item.des9 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des9 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange, translator, ProductsorServicesVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`ProductsorServicesTable`]: {
            data: ProductsorServicesVM.value,
        }

    }), [ProductsorServicesVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addProductsorServices,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            ProductsorServicesVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [ProductsorServicesVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={ProductsorServicesVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProductsorServicesComponent.propTypes = wizardProps;
export default withRouter(ProductsorServicesComponent);
